<fieldset>
	<br />
	<app-mixture-row 
					 *ngFor="let mortgage of mixtureFormArray.controls; let i=index"
					 [index]="i"
					 [canDelete]="mixtureFormArray.length > 1"
					 (removed)="mixtureFormArray.length > 1 && mixtureFormArray.removeAt($event)"
					 [rowData]="mortgage"
					 (change)="emitChanges($event)"
					 [displayErrors]="displayErrors">
	</app-mixture-row>
</fieldset>

<div class="d-flex justify-content-center text-center">
	<div *ngIf="mixtureFormArray.length > 0 && mixtureFormArray.length < maxArrayLength" class="m-add-line-btn"
		role="button" tabindex="0" (keypress)="simulateClick($event)" (click)="addrow()">
		<span class="app-font-bold">{{'MIXTURE.ADD'|translate}}</span>
	</div>

	<div *ngIf="mixtureFormArray.length === 0" class="m-add-line-btn" (click)="addrow()" role="button" tabindex="0"
		(keypress)="simulateClick($event)">
		<i class="fa fa-plus" aria-hidden="true"></i>
		<span>{{'MIXTURE.ADD'|translate}}</span>
	</div>
</div>
<br />



// WEBPACK FOOTER //
// ./src/app/mixture/mixture.component.html